import React, { useState } from "react";
import {
  makeStyles,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Collapse,
  Box,
  IconButton,
} from "@material-ui/core";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";

// [VinUni] Modal lọc trùng dùng chung cho các loại sản phẩm NCKH (Sách, Đề tài, Giải pháp, Sáng chế...)
// Props:
//  - open, onClose, loading
//  - data: mảng nhóm trùng từ BE, ví dụ [{ duplicateMonograph: [ { monograph: {...} }, ... ] }]
//  - groupKey: tên field nhóm trong mỗi phần tử data (vd "duplicateMonograph")
//  - itemKey: tên field item con (vd "monograph") -> đọc .title, .id
//  - onDelete: (id) => void  (tuỳ chọn)
//  - title: tiêu đề modal

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

function Row(props) {
  const { row, itemKey } = props;
  const [open, setOpen] = useState(false);
  const classes = useRowStyles();

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.title}
        </TableCell>
        <TableCell align="right">{row.numberOfDuplicate}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Các bản ghi trùng
              </Typography>
              <Table size="small" aria-label="duplicates">
                <TableHead>
                  <TableRow>
                    <TableCell>Tiêu đề</TableCell>
                    <TableCell>Tác giả/Thành viên</TableCell>
                    <TableCell align="right">Tác vụ</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.listDuplicate.map((duplicate) => {
                    const item = duplicate[itemKey] || {};
                    const authors =
                      item?.listAuthor?.join?.(", ") ||
                      item?.listMember?.join?.(", ") ||
                      item?.author ||
                      "Không có danh sách tác giả/thành viên";
                    return (
                      <TableRow key={item.id}>
                        <TableCell component="th" scope="row">
                          {item.title}
                        </TableCell>
                        <TableCell>{authors}</TableCell>
                        <TableCell align="right">
                          {props.onDelete && (
                            <Typography
                              className="table-action-buton"
                              variant="caption"
                              color="secondary"
                              style={{ cursor: "pointer" }}
                              onClick={() => props.onDelete(item.id)}
                            >
                              Xoá
                            </Typography>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function CheckDuplicateModal(props) {
  const { groupKey, itemKey } = props;

  const rowsData = (props.data || [])
    .filter((item) => item && Array.isArray(item[groupKey]) && item[groupKey].length > 0)
    .map((item, index) => ({
      key: index + 1,
      title: item[groupKey][0]?.[itemKey]?.title ?? "(Không có tiêu đề)",
      numberOfDuplicate: item[groupKey].length,
      listDuplicate: item[groupKey],
    }));

  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="lg">
      <DialogTitle>{props.title || "Danh sách bản ghi trùng theo tiêu đề"}</DialogTitle>
      <DialogContent>
        {props.loading ? (
          <Box display="flex" justifyContent="center" padding={3}>
            <CircularProgress />
          </Box>
        ) : rowsData.length === 0 ? (
          <Typography style={{ padding: 16 }}>Không tìm thấy bản ghi trùng.</Typography>
        ) : (
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell>Tiêu đề bản ghi trùng</TableCell>
                  <TableCell align="right">Số lượng trùng</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rowsData.map((row) => (
                  <Row key={row.key} row={row} itemKey={itemKey} onDelete={props.onDelete} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color="primary" autoFocus>
          Đóng
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CheckDuplicateModal;
